/** Parallel backend reads at any moment from one render. */
export const maxConcurrentReads = 6;

/** `Promise.all` with at most `limit` in flight. */
export async function mapLimit<T, R>({
  items,
  limit,
  fn,
}: {
  items: readonly T[];
  limit: number;
  fn: (item: T) => Promise<R>;
}): Promise<R[]> {
  const results: R[] = [];
  const pending = items.entries();
  async function worker() {
    while (true) {
      const next = pending.next();

      if (next.done) return;

      const [index, item] = next.value;
      results[index] = await fn(item);
    }
  }
  await Promise.all(
    Array.from({ length: Math.min(limit, items.length) }, () => worker()),
  );
  return results;
}
